import React, { createContext, useContext, useEffect, useState, useCallback, useMemo } from 'react';
import axios from 'axios';

const BASE = process.env.REACT_APP_BACKEND_URL;
const API = `${BASE}/api`;
const TOKEN_KEY = 'wss_customer_token';

const client = axios.create({ baseURL: API, timeout: 20000 });
client.interceptors.request.use((cfg) => {
  const t = typeof window !== 'undefined' ? localStorage.getItem(TOKEN_KEY) : null;
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

const Ctx = createContext(null);

export const CustomerAuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    const t = localStorage.getItem(TOKEN_KEY);
    if (!t) { setUser(null); setLoading(false); return; }
    try {
      const { data } = await client.get('/customer/me');
      setUser(data);
    } catch (e) {
      console.error('Customer /me failed:', e);
      localStorage.removeItem(TOKEN_KEY);
      setUser(null);
    } finally { setLoading(false); }
  }, []);

  useEffect(() => { load(); }, [load]);

  const login = async ({ email, password }) => {
    const { data } = await client.post('/customer/login', { email, password });
    localStorage.setItem(TOKEN_KEY, data.access_token);
    setUser(data.user);
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await client.post('/customer/register', payload);
    localStorage.setItem(TOKEN_KEY, data.access_token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => { localStorage.removeItem(TOKEN_KEY); setUser(null); };

  const value = useMemo(() => ({ user, loading, login, register, logout, client }), [user, loading]);
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
};

export const useCustomerAuth = () => useContext(Ctx) || { user: null, loading: true, login: () => {}, register: () => {}, logout: () => {} };
export const customerClient = client;
export const CUSTOMER_TOKEN_KEY = TOKEN_KEY;
